/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { baseApiService, type QueryParams } from './base'

export interface Filter extends QueryParams {
  expandGroups?: boolean
  fsiName?: string
  groupId?: number
  includeApprovers?: boolean
  parentId?: number
  sortBy?: string
  sortDesc?: boolean
  state?: string
  userId?: number
  filterId?: number
}

export interface FileACLResponse {
  userAcls: {
    NONE: number[]
    BROWSE: number[]
    WRITE: number[]
    ANNOTATE: number[]
    VIEW: number[]
    DELETE: number[]
    READ: number[]
  }
  groupAcls: {
    NONE: number[]
    BROWSE: number[]
    WRITE: number[]
    ANNOTATE: number[]
    VIEW: number[]
    DELETE: number[]
    READ: number[]
  }
}

export interface UpdateFileACLResponse {
  userAcls: {
    NONE: number[]
    BROWSE: number[]
    VIEW: number[]
    READ: number[]
    ANNOTATE: number[]
    WRITE: number[]
    DELETE: number[]
  }
  groupAcls: {
    NONE: number[]
    BROWSE: number[]
    VIEW: number[]
    READ: number[]
    ANNOTATE: number[]
    WRITE: number[]
    DELETE: number[]
  }
  [key: string]: unknown
}

class AclsApiService {
  async exportACLsReports(filter: Filter): Promise<void> {
    return baseApiService.fetch<void>('/api/reports/acl', {
      method: 'POST',
      body: filter
    })
  }

  // This api is not used anywhere in the app
  async getACLsReports(filter: Filter) {
    return baseApiService.fetch('/api/acls/report', {
      params: filter
    })
  }

  async getFileACL(aclId: number): Promise<FileACLResponse> {
    return baseApiService.fetch<FileACLResponse>(`/api/acls/${aclId}`)
  }

  async updateFileACL(aclId: number, data: UpdateFileACLResponse): Promise<void> {
    return baseApiService.fetch<void>(`/api/acls/${aclId}`, {
      method: 'PATCH',
      body: data
    })
  }

  async getUsersGrpsByAclForFsi(fsiId: number, level: string, isExpandGroups: boolean): Promise<FileACLResponse> {
    return baseApiService.fetch<FileACLResponse>(`/api/acls/${fsiId}?level=${level}&expandGroups=${isExpandGroups}`)
  }
}

export const aclsApiService = new AclsApiService()
